import React from "react";
import Hero from "../components/Hero";
import Portfolio from "../components/Portfolio";
import About from "../components/About";
import Contact from "../components/Contact";

const Home = () => {
  return (
    <>
      <Hero />
      <Portfolio />
      <About />
      <Contact />
    </>
  );
};

export default Home;
